import _ from "lodash";

const CURRENT_DRAFT_FIELDS = [
	"selectedValue",
	"invoiceItems",
	"estimates",
	"jobDetails"
];

const isPlainObject = value => Boolean(value && _.isPlainObject(value));

/**
 * Validate and clone the transient pricing state supplied by an embedded
 * pricing editor. This intentionally accepts pricing fields only; activity,
 * customer, company, job, and S3 identity remain owned by AmbiFi Cloud.
 *
 * @param {*} currentDraft Candidate options.currentDraft value.
 * @returns {Object|null} A detached pricing draft, or null when invalid.
 */
export function normalizeEstimatePrintCurrentDraft(currentDraft) {
	if (!isPlainObject(currentDraft)
		|| typeof currentDraft.selectedValue !== "string"
		|| !Array.isArray(currentDraft.invoiceItems)
		|| !Array.isArray(currentDraft.estimates)
		|| !isPlainObject(currentDraft.jobDetails)) {
		return null;
	}

	return _.cloneDeep(_.pick(currentDraft, CURRENT_DRAFT_FIELDS));
}

/**
 * Overlay validated transient pricing onto a Cloud-owned activity without
 * accepting any identity fields from the embedded caller.
 *
 * @param {Object} activity Cloud search/S3 activity source.
 * @param {Object} currentDraft Validated transient pricing draft.
 * @returns {Object} A detached activity with only pricing fields replaced.
 */
export function applyEstimatePrintCurrentDraft(activity = {}, currentDraft = null) {
	const normalizedDraft = normalizeEstimatePrintCurrentDraft(currentDraft);
	if (!normalizedDraft) {
		return _.cloneDeep(activity && typeof activity === "object" ? activity : {});
	}

	return {
		..._.cloneDeep(activity && typeof activity === "object" ? activity : {}),
		...normalizedDraft
	};
}

